import React, { useContext } from 'react';
import { Box } from '@mui/material';
import CustomProgressBar from '../../../components/CustomProgressBar';
import useTeamDashboardContext from '../context/useTeamDashboardContext';

export default function Progress() {
  const { progress } = useContext(useTeamDashboardContext);

  return (
    <Box padding={10}>
      <Box>
        <CustomProgressBar
          title=' Total MDs Plotted:'
          actualValue={progress?.data?.total?.actual ?? 0}
          targetValue={progress?.data?.total?.target ?? 0}
        />
      </Box>
      <Box pt={5}>
        <CustomProgressBar
          title='Plotted'
          actualValue={progress?.data?.plotted?.actual ?? 0}
          targetValue={progress?.data?.plotted?.target ?? 0}
        />
      </Box>
      <Box pt={5}>
        <CustomProgressBar
          title='Completed'
          actualValue={progress?.data?.completed?.actual ?? 0}
          targetValue={progress?.data?.completed?.target ?? 0}
        />
      </Box>
      <Box pt={5}>
        <CustomProgressBar
          title='Reach'
          actualValue={progress?.data?.reach?.actual ?? 0}
          targetValue={progress?.data?.reach?.target ?? 0}
        />
      </Box>
    </Box>
  );
}
